module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_01.c363e24c.svg";